<template>
  <el-row>
    <el-row type="flex" class="title-bar" style="justify-content:flex-end">
      <span>
        <el-radio-group class="mr-r10" v-model="searchLogType" @change="loadData">
          <el-radio :label="false">전체 로그</el-radio>
          <el-radio :label="true">필터링 로그</el-radio>
        </el-radio-group>
        <w-header-search-button @click="searchFlag = !searchFlag"></w-header-search-button>
      </span>
    </el-row>
    <el-table-wrapper v-loading="loading" @condition-change="setTableParameter" ref="logTable" :data="tableData" :total="total" :columns="columns" :show-custom-header="true" :show-search-tool="searchFlag" remote
     :pagination="true" :column-default="columnDefault">
    </el-table-wrapper>
  </el-row>
</template>

<script>
import moment from 'moment';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import findIndex from 'lodash/findIndex';
import { mapGetters } from 'vuex';

import { EMPTY_TEXT } from '@/utils/string';
import operionApi from '@/api/performance/service/operation-log';
import { columnDefault } from '@/constants/table';
import { getDateToString, getIntervalDatetimeParams } from '@/utils/date';

export default {
  name: 'WServiceLogList',
  data() {
    return {
      searchLogType: false,
      loading: false,
      columnDefault,
      tableData: [],
      total: 0,
      start: 0,
      limit: 50,
      searchParams: [],
      searchFlag: false,
    };
  },
  props: {
    active: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters(['selectedNode', 'activeManagetypeIds']),
    isLms() {
      return findIndex(this.activeManagetypeIds, (item) => item === 'LMS') >= 0;
    },
    columns() {
      const idx = findIndex(this.activeManagetypeIds, (item) => item === 'LMS');
      let logColumns;
      if (idx === -1) {
        logColumns = [
          {
            prop: 'logType',
            label: '로그종류',
            width: 150,
            showOverflowTooltip: true,
            searchable: true,
            formatter: this.getStringFormatter,
          },
          {
            prop: 'objName',
            label: '관리대상이름',
            width: 150,
            showOverflowTooltip: true,
            searchable: true,
            formatter: this.getStringFormatter,
          },
          {
            prop: 'message',
            label: '메시지',
            showOverflowTooltip: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'filterName',
            label: '정책이름',
            width: 150,
            showOverflowTooltip: true,
            searchable: true,
            formatter: this.getStringFormatter,
          },
          {
            prop: '@timestamp',
            label: '수집시각',
            showOverflowTooltip: true,
            formatter: this.getDateFormatter,
            width: 200,
          }];
      } else {
        logColumns = [
          {
            prop: 'logType',
            label: '로그종류',
            width: 150,
            showOverflowTooltip: true,
            searchable: true,
            formatter: this.getStringFormatter,
          },
          {
            prop: 'objName',
            label: '관리대상이름',
            width: 150,
            showOverflowTooltip: true,
            searchable: true,
            formatter: this.getStringFormatter,
          },
          {
            prop: 'originMessage',
            label: '메시지',
            showOverflowTooltip: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'filterName',
            label: '정책이름',
            width: 150,
            showOverflowTooltip: true,
            searchable: true,
            formatter: this.getStringFormatter,
          },
          {
            prop: 'timestamp',
            label: '수집시각',
            showOverflowTooltip: true,
            formatter: this.getDateFormatter,
            width: 200,
          }];
      }

      return logColumns;
    },
  },
  watch: {
    selectedNode: {
      immediate: true,
      deep: true,
      handler() {
        if (this.active) {
          this.searchParams = [];
          this.start = 0;
          this.limit = 50;
        }
      },
    },
    active: {
      handler(value) {
        if (value) {
          this.$refs.logTable.clearFilter();
          this.searchFlag = false;
          this.loadData();
        }
      },
    },
  },
  methods: {
    setTableParameter(data) {
      this.searchParams = data.searchParams;
      this.start = data.start;
      this.limit = data.limit;
      this.loadData();
    },
    getStringFormatter(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : value;
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        if (this.isLms) {
          return getDateToString(getIntervalDatetimeParams(value, 'hour', 9), 'YYYY-MM-DD HH:mm:ss');
        }
        return getDateToString(value, 'YYYY-MM-DD HH:mm:ss');
      }
      return EMPTY_TEXT;
    },
    loadData() {
      this.loading = true;
      const params = {
        serviceId: this.selectedNode.obj.objId,
        start: this.start,
        limit: this.limit,
        type: 'root',
        isFilterLogSearch: this.searchLogType,
      };
      const now = new Date();
      params.endDatetime = now.getTime();
      params.startDatetime = moment(now).subtract(24, 'hours').toDate().getTime();

      if (!isEmpty(this.searchParams)) {
        params.searchParams = this.searchParams;
      }
      operionApi.getServiceLogList(params).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
          this.total = response.data.total;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/operation/service/components/ServiceLogList.vue